<template>
  <header class="main-header" :class="headerClass">
    <!-- 헤더 바 -->
    <div class="header-bar">
      <div class="header-inner">
        <!-- 로고 -->
        <router-link to="/" class="logo">
          <img src="@/assets/logo/logo2.png" alt="엘리프 한신더휴 수원" class="logo-img logo-default" />
          <img src="@/assets/logo/logo1.png" alt="엘리프 한신더휴 수원" class="logo-img logo-active" />
        </router-link>

        <!-- 대메뉴 -->
        <nav class="gnb" @mouseenter="onMenuEnter" @mouseleave="onMenuLeave">
          <ul class="menu-dep1">
            <li
              v-for="(menu, index) in menuData"
              :key="index"
              class="dep1-item"
            >
              <router-link :to="menu.children[0].path" class="dep1-link">
                {{ menu.title }}
              </router-link>
            </li>
          </ul>
        </nav>

        <!-- 우측: 배지 + 전화번호 -->
        <div class="header-right">
          <img src="@/assets/logo/bnn_pop1_251208.png" alt="견본주택 개관 중" class="open-badge" />
          <a href="tel:1599-9923" class="phone-area">
            <span class="phone-icon">&#9742;</span>
            <span class="number">1599.9923</span>
          </a>
        </div>

        <!-- 모바일: 전화 + 햄버거 -->
        <div class="mobile-right">
          <a href="tel:1599-9923" class="mobile-phone-btn" aria-label="전화걸기">
            <span class="mobile-phone-icon">&#9742;</span>
          </a>
          <button
            class="hamburger-btn"
            :class="{ 'is-active': isMobileMenuOpen }"
            @click="toggleMobileMenu"
            aria-label="메뉴 열기/닫기"
          >
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
            <span class="hamburger-line"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- 서브메뉴 드롭다운 -->
    <div
      class="dropdown-panel"
      :class="{ 'is-open': isMenuHover }"
      @mouseenter="onMenuEnter"
      @mouseleave="onMenuLeave"
    >
      <div class="dropdown-inner">
        <!-- 로고 영역과 동일한 공간 확보 -->
        <div class="dropdown-left">
          <img src="@/assets/logo/logo1.png" alt="" class="logo-img" style="visibility: hidden;" />
        </div>

        <!-- 서브메뉴 그리드: 대메뉴와 동일한 flex:1 + center -->
        <div class="dropdown-center">
          <div
            v-for="(menu, index) in menuData"
            :key="index"
            class="sub-column"
          >
            <ul class="sub-list">
              <li v-for="(sub, subIndex) in menu.children" :key="subIndex">
                <a
                  v-if="sub.external"
                  :href="sub.path"
                  target="_blank"
                  class="sub-link"
                >{{ sub.title }}</a>
                <router-link
                  v-else
                  :to="sub.path"
                  class="sub-link"
                  @click="onMenuLeave"
                >{{ sub.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- 우측: header-right와 동일한 공간 확보 -->
        <div class="dropdown-right">
          <img src="@/assets/logo/bnn_pop1_251208.png" alt="" class="open-badge" style="visibility: hidden;" />
          <span class="phone-area" style="visibility: hidden;">
            <span class="phone-icon">&#9742;</span>
            <span class="number">1599.9923</span>
          </span>
        </div>
      </div>
    </div>

    <!-- 모바일 풀스크린 드로어 -->
    <div class="mobile-drawer" :class="{ 'is-open': isMobileMenuOpen }">
      <div class="mobile-drawer-inner">
        <nav class="mobile-nav">
          <ul class="mobile-menu-list">
            <li
              v-for="(menu, index) in menuData"
              :key="index"
              class="mobile-menu-item"
            >
              <button
                class="mobile-dep1-btn"
                :class="{ 'is-expanded': mobileExpandedIndex === index }"
                @click="toggleMobileAccordion(index)"
              >
                <span>{{ menu.title }}</span>
                <span class="mobile-arrow">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </button>
              <ul
                class="mobile-sub-list"
                :class="{ 'is-expanded': mobileExpandedIndex === index }"
              >
                <li v-for="(sub, subIndex) in menu.children" :key="subIndex">
                  <a
                    v-if="sub.external"
                    :href="sub.path"
                    target="_blank"
                    class="mobile-sub-link"
                    @click="closeMobileMenu"
                  >{{ sub.title }}</a>
                  <router-link
                    v-else
                    :to="sub.path"
                    class="mobile-sub-link"
                    @click="closeMobileMenu"
                  >{{ sub.title }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>

        <!-- 모바일 드로어 하단: 전화번호 -->
        <div class="mobile-drawer-footer">
          <a href="tel:1599-9923" class="mobile-footer-phone">
            <span class="mobile-footer-phone-icon">&#9742;</span>
            <span class="mobile-footer-phone-number">1599.9923</span>
          </a>
        </div>
      </div>
    </div>

    <!-- 모바일 오버레이 -->
    <div
      class="mobile-overlay"
      :class="{ 'is-open': isMobileMenuOpen }"
      @click="closeMobileMenu"
    ></div>
  </header>
</template>

<script>
export default {
  name: 'MainHeader',
  data() {
    return {
      isMenuHover: false,
      hoverTimeout: null,
      currentSection: 0,
      isScrolled: false,
      isMobileMenuOpen: false,
      mobileExpandedIndex: null,
      menuData: [
        {
          title: '사업안내',
          children: [
            { title: '사업개요', path: '/intro/overview' },
            { title: '브랜드소개', path: '/intro/brand' },
            { title: '입지환경', path: '/location/environment' },
            { title: '프리미엄', path: '/product/premium' },
            { title: '오시는길', path: '/location/direction' }
          ]
        },
        {
          title: '단지안내',
          children: [
            { title: '단지설계', path: '/complex/plan' },
            { title: '동호배치도', path: '/complex/layout' },
            { title: '커뮤니티', path: '/complex/community' }
          ]
        },
        {
          title: '세대안내',
          children: [
            { title: '세대정보', path: '/space/unit' }
          ]
        },
        {
          title: '분양안내',
          children: [
            { title: '모집공고', path: '/sale/recruit-notice' },
            { title: '공급안내', path: '/sale/supply' }
          ]
        },
        {
          title: '관심고객등록',
          children: [
            { title: '관심고객등록', path: '/reservation/register' }
          ]
        }
      ]
    }
  },
  computed: {
    isHome() {
      return this.$route.path === '/'
    },
    // 1번: 메인(섹션0), 2번: logo1+검정(is-transparent), 3번: logo2+흰색(is-light-mode)
    headerClass() {
      // 서브페이지
      if (!this.isHome) {
        return {
          'menu-active': this.isMenuHover,
          'is-transparent': true,
          'is-subpage': true,
          'is-scrolled': this.isScrolled
        }
      }
      return {
        'menu-active': this.isMenuHover,
        'is-transparent': this.currentSection === 1 || this.currentSection === 3 || this.currentSection === 5,
        'is-light-mode': this.currentSection === 2 || this.currentSection === 4
      }
    }
  },
  mounted() {
    window.addEventListener('section-change', this.onSectionChange)
    window.addEventListener('scroll', this.onScroll)
  },
  beforeUnmount() {
    window.removeEventListener('section-change', this.onSectionChange)
    window.removeEventListener('scroll', this.onScroll)
    document.body.style.overflow = ''
  },
  methods: {
    onSectionChange(e) {
      this.currentSection = e.detail
    },
    onScroll() {
      if (!this.isHome) {
        this.isScrolled = window.scrollY > 10
      }
    },
    onMenuEnter() {
      clearTimeout(this.hoverTimeout)
      this.isMenuHover = true
    },
    onMenuLeave() {
      this.hoverTimeout = setTimeout(() => {
        this.isMenuHover = false
      }, 80)
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
        this.mobileExpandedIndex = null
      }
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      document.body.style.overflow = ''
      this.mobileExpandedIndex = null
    },
    toggleMobileAccordion(index) {
      this.mobileExpandedIndex = this.mobileExpandedIndex === index ? null : index
    }
  }
}
</script>

<style scoped>
/* 헤더 */
.main-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* 헤더 바 */
.header-bar {
  position: relative;
  z-index: 2;
}

/* 초록 배경 (왼쪽 30px 띄움) */
.header-bar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 30px;
  right: 0;
  bottom: 0;
  background: var(--thehue-primary);
  transition: background 0.3s ease, left 0.3s ease;
}

/* 삼각형 접힘 */
.header-bar::after {
  content: '';
  position: absolute;
  bottom: -70px;
  left: 30px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 70px 0 0 90px;
  border-color: var(--thehue-primary) transparent transparent transparent;
  transition: opacity 0.3s ease;
}

/* 호버: 흰색 배경, 왼쪽 끝까지 */
.main-header.menu-active .header-bar::before {
  left: 0;
  background: #fff;
}

.main-header.menu-active .header-bar::after {
  opacity: 0;
}

/* 투명 모드 (2번 헤더) */
.main-header.is-transparent .header-bar::before {
  left: 0;
  background: transparent;
}

.main-header.is-transparent .header-bar::after {
  opacity: 0;
}

.main-header.is-transparent .logo-default {
  display: none !important;
}

.main-header.is-transparent .logo-active {
  display: block !important;
}

.main-header.is-transparent .dep1-link {
  color: #333;
}

.main-header.is-transparent .dep1-item:hover .dep1-link {
  color: var(--thehue-primary);
}

.main-header.is-transparent .phone-area {
  color: #333;
}

/* 투명 모드 + 호버 */
.main-header.is-transparent.menu-active .header-bar::before {
  left: 0;
  background: #fff;
}

.main-header.is-transparent.menu-active .dep1-link {
  color: #333;
}

/* 서브페이지: 투명 배경 + logo1 + 검정 글씨 */
.main-header.is-subpage:not(.is-scrolled) .header-bar::before {
  left: 0;
  background: transparent;
}

.main-header.is-subpage .header-bar::after {
  display: none;
}

.main-header.is-subpage.menu-active .header-bar::before {
  background: #fff;
}

/* 서브페이지 스크롤: 배경만 흰색 */
.main-header.is-subpage.is-scrolled .header-bar::before {
  background: #fff;
}


.header-inner {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 0 100px 0 60px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 로고 */
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
}

.logo-img {
  height: 60px;
  width: auto;
}

.logo-default { display: block; }
.logo-active { display: none; }
.main-header.menu-active .logo-default { display: none; }
.main-header.menu-active .logo-active { display: block; }

/* GNB 대메뉴 */
.gnb {
  flex: 1;
  display: flex;
  justify-content: center;
}

.menu-dep1 {
  display: flex;
  list-style: none;
}

.dep1-item {
  text-align: center;
  width: 130px;
}

.dep1-link {
  display: block;
  line-height: 130px;
  font-family: var(--font-family);
  font-size: 17px;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  letter-spacing: -0.3px;
  transition: color 0.3s ease;
}

.main-header.menu-active .dep1-link {
  color: #333;
  font-weight: 600;
}

.dep1-item:hover .dep1-link {
  color: rgba(255, 255, 255, 0.6);
}

.main-header.menu-active .dep1-item:hover .dep1-link {
  color: var(--thehue-primary);
}

/* 우측 영역 */
.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
}

.open-badge {
  height: 42px;
  width: auto;
}

.phone-area {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #fff;
  flex-shrink: 0;
  transition: color 0.3s ease;
}

.main-header.menu-active .phone-area {
  color: #333;
}

.phone-area .phone-icon {
  font-size: 22px;
}

.phone-area .number {
  font-family: var(--font-family2);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
}

/* ===== 드롭다운 패널 ===== */
.dropdown-panel {
  position: absolute;
  top: 130px;
  left: 0;
  right: 0;
  z-index: 1;
  background: var(--sub-color);
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.dropdown-panel.is-open {
  max-height: 260px;
  border-top: 1px solid #ddd;
}

.dropdown-inner {
  width: 100%;
  padding: 0 100px 0 60px;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

/* 로고 영역과 동일한 크기를 차지 */
.dropdown-left {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.dropdown-left .logo-img {
  height: 60px;
  width: auto;
}

/* 서브메뉴 영역: gnb와 동일한 flex 구조 */
.dropdown-center {
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 24px 0 28px;
}

.sub-column {
  text-align: center;
  width: 130px;
  flex-shrink: 0;
}

/* 우측: header-right와 동일한 크기를 차지 */
.dropdown-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
}

.sub-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sub-link {
  display: block;
  font-family: var(--font-family);
  font-size: 13px;
  font-weight: 500;
  color: #555;
  letter-spacing: -0.5px;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease;
}

.sub-link:hover {
  color: var(--thehue-primary);
}

/* 라이트 모드 (3번 헤더: logo2 + 흰 글씨) */
.main-header.is-light-mode .header-bar::before {
  left: 0;
  background: transparent;
}

.main-header.is-light-mode .header-bar::after {
  opacity: 0;
}

.main-header.is-light-mode .dep1-link {
  color: #fff;
}

.main-header.is-light-mode .dep1-item:hover .dep1-link {
  color: rgba(255, 255, 255, 0.6);
}

.main-header.is-light-mode .phone-area {
  color: #fff;
}

/* 라이트 모드 + 호버: 섹션2와 동일 */
.main-header.is-light-mode.menu-active .header-bar::before {
  left: 0;
  background: #fff;
}

.main-header.is-light-mode.menu-active .logo-default {
  display: none !important;
}

.main-header.is-light-mode.menu-active .logo-active {
  display: block !important;
}

.main-header.is-light-mode.menu-active .dep1-link {
  color: #333;
  font-weight: 600;
}

.main-header.is-light-mode.menu-active .dep1-item:hover .dep1-link {
  color: var(--thehue-primary);
}

.main-header.is-light-mode.menu-active .phone-area {
  color: #333;
}

/* ===== 모바일 전용 요소: 데스크탑에서 숨김 ===== */
.mobile-right {
  display: none;
}

.mobile-drawer {
  display: none;
}

.mobile-overlay {
  display: none;
}

/* ===== 모바일 반응형 (768px 이하) ===== */
@media (max-width: 768px) {
  /* 헤더 높이 축소 */
  .header-inner {
    height: 60px;
    padding: 0 16px;
  }

  /* 로고 축소 */
  .logo-img {
    height: 36px;
  }

  /* GNB 메뉴 숨김 */
  .gnb {
    display: none;
  }

  /* 우측 영역 (전화번호, 배지) 숨김 */
  .header-right {
    display: none;
  }

  /* 모바일 우측: 전화 아이콘 + 햄버거 */
  .mobile-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    position: relative;
    z-index: 1;
  }

  /* 모바일 전화 버튼 */
  .mobile-phone-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--thehue-primary);
    text-decoration: none;
    transition: background 0.3s ease;
  }

  .mobile-phone-btn:hover {
    background: var(--thehue-primary-dark, #7a1828);
  }

  .mobile-phone-icon {
    font-size: 20px;
    color: #fff;
  }

  /* 햄버거 버튼 */
  .hamburger-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    gap: 5px;
  }

  .hamburger-line {
    display: block;
    width: 22px;
    height: 2px;
    background: #333;
    border-radius: 1px;
    transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1),
                opacity 0.25s ease;
    transform-origin: center;
  }

  /* 햄버거 → X 트랜지션 */
  .hamburger-btn.is-active .hamburger-line:nth-child(1) {
    transform: translateY(7px) rotate(45deg);
  }

  .hamburger-btn.is-active .hamburger-line:nth-child(2) {
    opacity: 0;
    transform: scaleX(0);
  }

  .hamburger-btn.is-active .hamburger-line:nth-child(3) {
    transform: translateY(-7px) rotate(-45deg);
  }

  /* 배경 바: 왼쪽 마진 제거, 흰색 배경 */
  .header-bar::before {
    left: 0;
    background: #fff;
  }

  /* 삼각형 숨김 */
  .header-bar::after {
    display: none;
  }

  /* 모바일에서는 항상 logo1(컬러) 표시 */
  .logo-default {
    display: none !important;
  }

  .logo-active {
    display: block !important;
  }

  /* 투명 모드 오버라이드: 모바일은 항상 흰색 배경 */
  .main-header.is-transparent .header-bar::before {
    background: #fff;
  }

  .main-header.is-light-mode .header-bar::before {
    background: #fff;
  }

  /* 데스크탑 드롭다운 패널 숨김 (모바일 드로어 사용) */
  .dropdown-panel {
    display: none !important;
  }

  /* ===== 모바일 풀스크린 드로어 ===== */
  .mobile-drawer {
    display: block;
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: #fff;
    transform: translateX(100%);
    transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-drawer.is-open {
    transform: translateX(0);
  }

  .mobile-drawer-inner {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 20px 0;
  }

  /* 모바일 네비게이션 */
  .mobile-nav {
    flex: 1;
  }

  .mobile-menu-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .mobile-menu-item {
    border-bottom: 1px solid #eee;
  }

  /* 대메뉴 버튼 */
  .mobile-dep1-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px 24px;
    border: none;
    background: transparent;
    font-family: var(--font-family);
    font-size: 16px;
    font-weight: 600;
    color: #333;
    cursor: pointer;
    letter-spacing: -0.3px;
    transition: color 0.2s ease;
  }

  .mobile-dep1-btn:hover,
  .mobile-dep1-btn.is-expanded {
    color: var(--thehue-primary);
  }

  .mobile-arrow {
    display: flex;
    align-items: center;
    transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    color: #999;
  }

  .mobile-dep1-btn.is-expanded .mobile-arrow {
    transform: rotate(180deg);
    color: var(--thehue-primary);
  }

  /* 소메뉴 아코디언 */
  .mobile-sub-list {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 0;
    overflow: hidden;
    background: #f8f8f8;
    transition: max-height 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .mobile-sub-list.is-expanded {
    max-height: 400px;
  }

  .mobile-sub-link {
    display: block;
    padding: 12px 24px 12px 40px;
    font-family: var(--font-family);
    font-size: 14px;
    font-weight: 400;
    color: #666;
    text-decoration: none;
    letter-spacing: -0.3px;
    transition: color 0.2s ease, background 0.2s ease;
  }

  .mobile-sub-link:hover {
    color: var(--thehue-primary);
    background: #f0f0f0;
  }

  /* 모바일 드로어 하단: 전화번호 */
  .mobile-drawer-footer {
    padding: 24px;
    border-top: 1px solid #eee;
  }

  .mobile-footer-phone {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 14px 24px;
    background: var(--thehue-primary);
    color: #fff;
    text-decoration: none;
    border-radius: 8px;
    transition: background 0.3s ease;
  }

  .mobile-footer-phone:hover {
    background: var(--thehue-primary-dark, #7a1828);
  }

  .mobile-footer-phone-icon {
    font-size: 20px;
  }

  .mobile-footer-phone-number {
    font-family: var(--font-family2);
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
  }

  /* 모바일 오버레이 */
  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 998;
    background: rgba(0, 0, 0, 0.4);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }

  .mobile-overlay.is-open {
    opacity: 1;
    visibility: visible;
  }

  /* 서브페이지 모바일 */
  .main-header.is-subpage .header-bar::before {
    background: #fff;
  }

  .main-header.is-subpage:not(.is-scrolled) .header-bar::before {
    background: #fff;
  }
}
</style>
